import { atom } from 'jotai';

import { AddPersonWizardStep } from './AddPersonWizard.constants';

export const addPersonWizardStepState = atom<AddPersonWizardStep>('role');
